import { ROSTER_CSV_FORMATS } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'oneroster0',
    components: {},
})

export default class OneRoster0 extends Vue {
    @Prop()
    private ssoDetails: any;

    private rosterFormat: any = ROSTER_CSV_FORMATS;
}
